import React, { createContext, useContext, useState, useEffect } from "react";

// Create AuthContext
const AuthContext = createContext();

// Provider component to wrap the app
export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    try {
      // Load initial state from sessionStorage
      const storedAuth = sessionStorage.getItem("auth");
      return storedAuth ? JSON.parse(storedAuth) : { isAuthenticated: false, role: null };
    } catch (error) {
      console.error("Error parsing auth data from sessionStorage", error);
      return { isAuthenticated: false, role: null };
    }
  });

  const [user, setUser] = useState(() => {
    try {
      // Load user info from sessionStorage
      const storedUser = sessionStorage.getItem("user");
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error("Error parsing user data from sessionStorage", error);
      return null;
    }
  });

   // Detect and handle domain change
   useEffect(() => {
    const currentDomain = window.location.hostname;
    const storedDomain = sessionStorage.getItem("domain");

    if (storedDomain && storedDomain !== currentDomain) {
      console.log("Domain has changed, clearing sessionStorage.");
      // sessionStorage.removeItem("auth");
      // sessionStorage.removeItem("user");
      sessionStorage.clear(); // Clear sessionStorage if domain changes
    }

    // Save the current domain to sessionStorage
    sessionStorage.setItem("domain", currentDomain);
  }, []);

  useEffect(() => {
    try {
      // Save auth state to sessionStorage whenever it changes
      sessionStorage.setItem("auth", JSON.stringify(auth));
      sessionStorage.setItem("user", JSON.stringify(user));
    } catch (error) {
      console.error("Error saving to sessionStorage", error);
    }
  }, [auth, user]);

  const login = (userData) => {
    setAuth({ isAuthenticated: true, role: userData.role });
  
    // Ensure permissions are stored as an array of numbers
    const permissionsArray = userData.permission
      ? userData.permission.split(",").map(Number)
      : [];
  
    setUser({ ...userData, permission: permissionsArray });
  };
  

  const logout = () => {
    setAuth({ isAuthenticated: false, role: null });
    setUser(null);
    sessionStorage.removeItem("auth");
    sessionStorage.removeItem("user");
  };

  return (
    <AuthContext.Provider value={{ user, auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to access AuthContext
export const useAuth = () => useContext(AuthContext);
